import { api } from './client';
import type { BindRequest, BindResponse, BoardResponse } from '../types';

// --- Boards API (SC-2872) — the SC-2870 wire ----------------------------------
//
// Every build speaks the real endpoints. Until the BE board module landed this
// file carried a DEV-gated fixture binder behind the same shapes (the contract
// proposed on the BE ticket, 2026-08-03); the cutover deleted it, as designed.
// Server-side shell overlays are a later BE slice — until then the param merge
// is `request ⟵ spec default` and workspace/tile selections live in the
// session-scoped shell stores.

export const boardsApi = {
  list: (catalogId: string): Promise<BoardResponse[]> =>
    api.get<BoardResponse[]>(`/catalogs/${catalogId}/boards`),

  get: (catalogId: string, boardId: string): Promise<BoardResponse> =>
    api.get<BoardResponse>(`/catalogs/${catalogId}/boards/${encodeURIComponent(boardId)}`),

  /** Bind (run) a board's queries under the viewer's own scope. `params` are
   *  per-request overrides (the tile control's selection); the server merges
   *  request ⟵ spec default (⟵ the viewer's shell selection, once the BE shell
   *  slice lands). Failures are PER-QUERY (`{error}` in the result envelope) —
   *  an HTTP error here means a board-level problem. */
  bind: (catalogId: string, boardId: string, body: BindRequest = {}): Promise<BindResponse> =>
    api.post<BindResponse>(
      `/catalogs/${catalogId}/boards/${encodeURIComponent(boardId)}/bind`,
      body,
    ),

  /** Delete a created board (SC-2870 rights: creator, or ORG_OWNER as the
   *  escape hatch; confirm-gated in the UI). */
  remove: (catalogId: string, boardId: string): Promise<void> =>
    api.delete<void>(`/catalogs/${catalogId}/boards/${encodeURIComponent(boardId)}`),
};
